/**
 * @generated SignedSource<<288d50e47daa7606b7083e561a61526e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Plans$data = {
  readonly jira: {
    readonly advancedRoadmapsNavigation: {
      readonly hasCreateSamplePlanPermissions: boolean | null;
      readonly hasEditPermissions: boolean | null;
      readonly hasGlobalPlansAdminPermissions: boolean | null;
    } | null;
    readonly hasIsPlansExpanded?: "JiraQuery";
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4PlansForLanding">;
  readonly " $fragmentType": "Nav4Plans";
};
export type Nav4Plans$key = {
  readonly " $data"?: Nav4Plans$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Plans">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "isPlansExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Plans",
  "selections": [
    {
      "condition": "isPlansExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "Nav4PlansForLanding"
        }
      ]
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "isPlansExpanded",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "hasIsPlansExpanded",
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraAdvancedRoadmapsNavigation",
          "kind": "LinkedField",
          "name": "advancedRoadmapsNavigation",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasEditPermissions"
            },
            {
              "kind": "ScalarField",
              "name": "hasCreateSamplePlanPermissions"
            },
            {
              "kind": "ScalarField",
              "name": "hasGlobalPlansAdminPermissions"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "d4eb6e77059dc70179f1a9c3a44735c3";

export default node;
